import React from 'react';
import Input from '../elements/Input';

const LawyerCosts = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-2 border-b pb-1 dark:text-white">Lawyer / Costs</h2>
      <div className="flex flex-col gap-6 my-6">
        <Input label="Fee Earner" type="text" name="fee_earner" value={formData.fee_earner} onChange={handleChange} />
        <div className='grid grid-cols-2 gap-6'>
          <div className="mb-4 items-center">
            <label className="block font-semibold mb-1 text-gray-800 dark:text-white">Fixed Fee Agreed</label>
            <div className="flex items-center">
              <input
                type="radio"
                id="fixed_fee_agreed_yes"
                name="fixed_fee_agreed"
                value="Yes"
                checked={formData.fixed_fee_agreed === 'Yes'}
                onChange={handleChange}
                className="mr-2"
              />
              <label htmlFor="fixed_fee_agreed_yes" className="mr-4 text-gray-700 dark:text-gray-300">Yes</label>

              <input
                type="radio"
                id="fixed_fee_agreed_no"
                name="fixed_fee_agreed"
                value="No"
                checked={formData.fixed_fee_agreed === 'No'}
                onChange={handleChange}
                className="mr-2"
              />
              <label htmlFor="fixed_fee_agreed_no" className="text-gray-700 dark:text-gray-300">No</label>
            </div>
          </div>
          <Input className={formData.fixed_fee_agreed === 'No' ? "hidden" : ""} label="Fixed Fee" type="number" name="fixed_fee" value={formData.fixed_fee} onChange={handleChange} />
        </div>
        <div className='grid grid-cols-2 gap-6'>
          <div className="mb-4">
            <label className="block font-semibold mb-1 text-gray-800 dark:text-white">Hourly Rate Agreed</label>
            <div className="flex items-center">
              <input
                type="radio"
                id="hourly_rate_agreed_yes"
                name="hourly_rate_agreed"
                value="Yes"
                checked={formData.hourly_rate_agreed === 'Yes'}
                onChange={handleChange}
                className="mr-2"
              />
              <label htmlFor="hourly_rate_agreed_yes" className="mr-4 text-gray-700 dark:text-gray-300">Yes</label>

              <input
                type="radio"
                id="hourly_rate_agreed_no"
                name="hourly_rate_agreed"
                value="No"
                checked={formData.hourly_rate_agreed === 'No'}
                onChange={handleChange}
                className="mr-2"
              />
              <label htmlFor="hourly_rate_agreed_no" className="text-gray-700 dark:text-gray-300">No</label>
            </div>
          </div>
          <Input className={formData.hourly_rate_agreed === 'No' ? "hidden" : ""} label="Hourly Rate" type="number" name="hourly_rate" value={formData.hourly_rate} onChange={handleChange} />
        </div>
        <div className="md:col-span-2">
          <label className="block font-semibold mb-1 dark:text-white">Alternative Cost Arrangement (e.g., Pro-Bono)</label>
          <Input type="text" name="alternative_cost" value={formData.alternative_cost} onChange={handleChange} />
        </div>
      </div>
    </div>
  );
};

export default LawyerCosts;
